// Renders the six expiration buckets as clickable quick-filter cards.
// Adapts `metrics` (`{ id, label, count }`, from `hooksV2.js`) into the
// `FilterCards` options shape. The toggle-to-deselect behavior lives in
// `handleBucketChange` (`hooksV2.js`) — this component only wires the
// selection through.
import React, { useMemo } from 'react';
import {
  Box,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { FilterCards } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';

const LeaseInfoCardsV2 = ({ metrics, onChange, selectedBucketId }) => (
  <FilterCards
    options={useOptions({ metrics })}
    onChange={onChange}
    value={selectedBucketId}
    sx={{
      padding: 2,
      overflowX: 'auto',
      width: '100%',
    }}
  />
);

const useOptions = ({ metrics }) => {
  return useMemo(() => {
    return metrics?.map((metric) => {
      return {
        id: metric.id,
        component: (
          <Box>
            <Typography variant="titleSmall" marginBottom={1} component="div">
              {metric.label}
            </Typography>
            <Typography variant="titleSmall" component="div">
              <strong>{metric.count}</strong>
            </Typography>
          </Box>
        ),
        sx: {
          width: 260,
        },
      };
    });
  }, [metrics]);
};

export default LeaseInfoCardsV2;
